module.exports = __webpack_public_path__ + "static/media/Mortgage.7de58759.svg";